




















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem, Row } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop() id: number | undefined;
  @Prop() disabled : Boolean;
  model: proxy.ChannelTypeDto = new proxy.ChannelTypeDto();
  allchannels = [];
  channels = [];
  // channelids = [];
  channelTypeChannels = [];
  merchants = [];
  // disabled = false;
  groupflags = [];
  flag = '';
  showModal = false;
  modalDisabled = false;
  columns4 = [
    {
      title: "序号",
      width: 80,
      slot: "xuhao",
    },
    {
      title: "名称",
      key: "channelName",
    },
    {
      title: "权重",
      slot: "weight",
    },
    {
      title: "状态",
      slot: "channelStatus",
    },
  ];
  get prox() {
    return new proxy.ChannelTypeServiceProxy();
  }
  syncrate() {
    if (!this.flag) {
      this.merchants.map(x => {
        x.rate = this.model.rate;
      })
    } else {
      debugger;
      this.merchants.map(x => {
        if (x.groupFlag == this.flag) {
          this.$set(x, 'rate', this.model.rate)
        }
      })
    }
    this.merchants = this.merchants.filter(x => 1 == 1);
  }
  quanxuan() {
    this.merchants.map(x => {
      x.check = true;
    })
    this.$forceUpdate();
  }
  clearxuanzhong() {
    this.merchants.map(x => {
      x.check = false;
    })
    this.$forceUpdate();
  }
  jinyongchange(e) {
    if (e) {
      this.channels = this.allchannels.filter((x) => x.status == 0);
    } else {
      this.channels = this.allchannels;
    }
  }
  rowchange(row, index) {
    this.channelTypeChannels[index] = row;
  }
  
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  created() {
    
  }

  save() {
      let arr = this.merchants.filter(x => x.check).map(x => {
      let m = this.model.merchantChannelTypes.find(p => p.merchantId == x.id);
      console.log(m);
      m = m || new proxy.MerchantChannelTypeDto();
      m.merchantId = x.id;
      m.rate = x.rate;
      return m;
      });
      let arr2 = this.merchants.map(x => {
      let m = this.model.merchantAgentRates.find(p => p.merchantId == x.id);
      m = m || new proxy.MerchantAgentRateDto();
      m.merchantId = x.id;
      m.agentRate = x.agentRate;
      return m;
      })
      this.model.merchantChannelTypes = arr;
      this.model.merchantAgentRates = arr2;
      (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
          this.prox.saveMerchantChannelType(this.model).then(() => {
          (this.$refs.roleForm as any).resetFields();
          this.$Notice.success({ title: "保存成功" });
          this.$emit("save-success");
          this.$emit("input", false);
          });
      }
      });
  }

  visibleChange(value: boolean) {
      if (!value) {
          this.$emit("input", value);
      } else {
          this.disabled = true;
          this.flag = '';
          this.groupflags = [];
          let req2 = new proxy.MerchantSimpleInputDto();
          new proxy.MerchantServiceProxy().queryAllList(req2).then((x) => {
              this.$set(this, 'merchants', x);
              this.merchants.map((x) => {
                  x.check = false;
                  if (x.groupFlag != null && (this.groupflags.length == 0 || this.groupflags.findIndex(g => g == x.groupFlag) == -1)) {
                      this.groupflags.push(x.groupFlag);
                  }
              });
              this.prox.queryMerchantChannelType(this.id).then((x) => {
                  this.model = x;
                  this.model.merchantChannelTypes = this.model.merchantChannelTypes || [];
                  this.model.merchantAgentRates = this.model.merchantAgentRates || [];
                  this.merchants.map((c) => {
                      let i = this.model.merchantChannelTypes.findIndex(
                      (p) => p.merchantId == c.id
                      );
                      if (i != -1) {
                      c.check = true;
                      c.rate =
                          this.model.merchantChannelTypes[i].rate; // 这里如果给商户费率设置的是0的话会自动变成产品的费率   明天看下改一下
                      } else {
                      c.rate = this.model.rate;
                      }
                  });
                  this.merchants.map((c) => {
                      let i = this.model.merchantAgentRates.findIndex(
                      (p) => p.merchantId == c.id
                      );
                      if (i != -1) {
                      c.agentRate = this.model.merchantAgentRates[i].agentRate || 0;
                      } else {
                      c.agentRate = 0;
                      }
                  });
                  this.disabled = false
              });

          });
      }
  }

  roleRule = {
    suppName: [
      {
        required: true,
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
  };
}
